'use client';

import { useClearModalHashOnMount, useEscapeKeyAppRouter } from '@weberus/next-libs/feature/hash-modal-app-router';

export const ProjectInitializer = () => {
  useClearModalHashOnMount();
  useEscapeKeyAppRouter();

  return null;
};
